import * as types from '../actions/types'

const initialState = {
    loading : false,
    warehouses : [],
    error : ""
}


const warehouseReducer = (state = initialState , action) => {

    switch(action.type){

        case types.FETCH_WAREHOUESES_REQUEST :{
            return {
                ...state,
                loading : true
            }
        }
        case types.FETCH_WAREHOUESES_SUCCESS :{
            return {
                ...state,
                loading : false,
                warehouses : action.payload
            }
        }
        case types.FETCH_WAREHOUESES_FAILED :{
            return {
                ...state,
                loading : false,
                error : action.payload
            }
        }
        default:{
            return {
                ...state
            }
        }
    }
}



export default warehouseReducer